// extracted by mini-css-extract-plugin
module.exports = {"feedbackContainer":"FeedbackRatings_feedbackContainer__31D04","feedbackList":"FeedbackRatings_feedbackList__2YqWb","feedbackItem":"FeedbackRatings_feedbackItem__VcONV"};